export default "__VITE_ASSET__CadAOEVQ__"